import './App.css';
import { useEffect, useRef, useLayoutEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import MainPoint from './mainPoint';
import ParallaxLayout from './parallaxLayout';
import Small from './small';
import SwiperChangeLayout from './swiperChangeLayout/swiperChangeLayout';
import Battery from './battary';
import Header from './header';
import Overview from './overview';
import Temperature from './temperature';
import Hundred from './hundred';
import Dissipate from './dissipate';
import Notes from './notes';
gsap.registerPlugin(ScrollTrigger);
// ScrollTrigger.normalizeScroll(true);

let language = document.querySelector('meta[name="language"]').content;
document.getElementById('root').setAttribute('lang', language);
let json =
  language === 'cn'
    ? {
        text1: '观看视频',
        text2:
          '探索工艺结构和补光性能边界，让创新技术先于想象，实现紧密结构的小型口袋灯迸发40W峰值大功率；不负每一份热爱，自在创作，立光见影。',
        text3: '40W巨光灯源',
        text4: '电子回压散热系统',
        text5: '手掌大小，便携出行',
        text6: '快充续航，边充边用',
        text7: '巨光灯源',
        text8: '14000Lux<div class="mainText">¹</div>',
        text9: 'CRI≥96',
        text10: 'TLCI≥97',
        text11: '精密建模<br /><div class="mainText">变频散热</div>',
        text12:
          '独创电子回压散热系统，应用流体力学，结合姿态模型的动态风速控制算法，引入陀螺仪变量建模设计散热器和FOC变频风扇，优化散热片工艺，充分保障散热效率，<div class="mainText">支持智能控温，可根据不同功率输出，自适用调节散热风速。</div>',
        text13: '<div class="mainText">手掌大小</div><br />一手握持',
        text14: '整机净重320g，手掌大小。',
        text15: '小巧便携，轻松装进口袋。',
        text16: '<div class="mainText">宽域色温</div><br />稳定输出',
        text17:
          '双色灯珠紧密排列组合，共计176颗灯珠带来满血功率，口袋灯也能实现主光灯具的亮度。<div class="mainText">双色温峰值功率均可达40W，CRI≥96，TLCI≥97，补光无频闪更稳定。</div>',
        text18: '支持双色温调节',
        text19: '2700-6200K',
        text20: '该参数为实验室环境，4300K情况下100%亮度的照度数值。',
        text21: '<div class="mainText">双旋钮设计</div><br />精细调控',
        text22:
          '<div class="mainText">色温和亮度分别支持旋钮调节</div>，实现光效精准控制，当前参数一目了然。',
        text23: '<div class="mainText">一体支架</div><br />360°方向可调',
        text24:
          '一体可调节支架，内置2个1/4螺口便于外接通用脚架，<div class="mainText">使用常规三脚架即可固定搭建出简单的补光场景。</div>',
        text25: '<div class="mainText">轻补光</div><br />提升画面质感',
        text26:
          '<div class="mainText">智云五倍M40既有口袋灯的轻便属性，又具备专业灯具大功率</div>，让拍摄场景不再拘于性能限制，充分发挥你的移动摄影潜能。\t',
        text27: '视频直播',
        text28: '人像补光',
        text29: '氛围补光',
        text30: '<div class="mainText">自适应</div><br />充电技术',
        text31:
          '内置2颗18650规格电池，4个LED电量显示，10W功率续航达1H 37min，<div class="mainText">支持PD快充供电，可实现边使用，边动态充电。</div>²',
        text32: '峰值功率下，可持续补光',
        text33: '29分钟',
        text34: '支持',
        text35: 'PD协议快充',
        text36: '支持',
        text37: '<div class="mainText">边充边峰值功率使用</div>',
        text38:
          '使用40W以上PD快充适配器，可实现全功率输出和电池充电，纯电池供电状态，40W功率下可实现29分钟持续补光，电池最大充电输入功率为15W。',
        text39: '口袋巨光灯',
      }
    : {
        text1: 'Watch Video',
        text2:
          'ZHIYUN pushes the boundaries of technological structure and lighting performance, bringing the 40W pocket fill light to creators who are weary of cumbersome equipment and seek for more efficient workflow. M40 responds to your calls for simplicity, reifying innovation and utility in its compact body.',
        text3: '40W Powerful Pocket Light',
        text4: 'DynaVort Cooling System™',
        text5: 'Tiny But Professional',
        text6: 'Real-Time & Fast Charge',
        text7: 'Ultra-Bright ',
        text8: '14000 Lux<div class="mainText">¹</div>',
        text9: 'CRI≥96',
        text10: 'TLCI≥97',
        text11:
          '<div class="mainText">Variable-Frequency Cooling</div><br />Via Algorithm Control',
        text12:
          'M40 adopts the DynaVort Cooling System™ that consists of gyroscope modeling heat sink, FOC fans, and attitude-control algorithm to prevent overheating. The DynaVort technology that applies the fluid dynamics, <div class="mainText">raises the cooling efficiency by substantially enhancing the airflow emissions through intelligent control.</div>',
        text13: '<div class="mainText">Palm-Sized</div><br />Right In One Hand',
        text14: 'Palm-sized that weighs only 320g.',
        text15: 'Fits perfectly in pockets.',
        text16:
          '<div class="mainText">Wide Color Temperature</div><br />Excellent Color Rendition',
        text17:
          '176 LED chips bring an incredible illuminance that rivals the key light provided by bigger equipment. <div class="mainText"> Both cool and warm colors enable the max power output at 40W with no strobes. CRI≥96, TLCI≥97. </div>',
        text18: 'Support bi-color adjustment',
        text19: '2700-6200K',
        text20:
          '*The data is gathered from internal experiments of ZHIYUN laboratories when the M40 works at 4300K color temperature with 100% brightness. ',
        text21:
          '<div class="mainText">Dual Wheels</div><br />For Accurate Dimming ',
        text22:
          'Precise dimming of <div class="mainText">color temperature and brightness are available via two separate wheels</div>, giving you smooth control at fingertips.',
        text23: '360° Rotational Stand',
        text24:
          'The rotational stand of M40 extends possibilities for various occasions, while two 1/4" screw holes allow the M40 to be mounted on a tripod or light stand, <div class="mainText">offering a fast lighting setup than ever.</div>',
        text25:
          '<div class="mainText">Simplified Setup</div><br />For Quality Shots',
        text26:
          'M40 is <div class="mainText">handy yet powerful enough</div> to seamlessly fit in various lighting scenarios, enabling you to reach full potential with the professional lighting effect. \t',
        text27: 'Livestream Lighting',
        text28: 'Portrait Lighting',
        text29: 'Mood Lighting',
        text30: '<div class="mainText">Adaptive</div> Charging Technology',
        text31:
          'With 4 LED indicator lights that display battery level and two 18650 batteries built in, M40 supports <div class="mainText">PD fast charge protocol that allows a real-time charging</div>². Non-stop work at 10W can last for 1h 37min. ',
        text32: 'Provide Continuous Lighting With Peak Illuminance',
        text33: '29 Min',
        text34: 'Support',
        text35: 'PD Fast Charge Protocol',
        text36: 'Support',
        text37:
          '<div class="mainText">Max Power Output With Real-time Charge  </div>',
        text38:
          '*Support the full power output and battery charging at the same time via a PD fast charger above 40W. M40 can work for 29 min at 40W run by batteries only. The maximum charging input power of batteries is 15W.',
        text39: 'Powerful Pocket Light',
      };

function is_weixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

let isWeiXin = is_weixin();

function App() {
  const [textData, setTextData] = useState(json);
  const smoother = useRef(null);

  useEffect(() => {
    async function fetchData() {
      let response = await fetch(
        `https://www.zhiyun-tech.com/website/in18/m40/${language}.json`,
      );
      if (response.ok) {
        let json = await response.json();
        function formatText(text) {
          if (text.indexOf('{') < 0 && text.indexOf('_') < 0) {
            return text;
          } else if (text.indexOf('{') >= 0) {
            let rightBrackets = text.indexOf('{');
            let leftBrackets = text.indexOf('}') + 1;
            let oldText = text.slice(rightBrackets, leftBrackets);
            let newText = `<div class="mainText">${text.slice(
              rightBrackets + 1,
              leftBrackets - 1,
            )}</div>`;

            return formatText(text.replace(oldText, newText));
          } else if (text.indexOf('_') >= 0) {
            let brackets = text.indexOf('_');
            let oldText = text.slice(brackets, brackets + 1);
            let newText = `<br />`;
            return formatText(text.replace(oldText, newText));
          }
        }

        for (let item in json) {
          json[item] = formatText(json[item]);
        }
        console.log(json);
        setTextData(json);
      } else {
        console.log('HTTP-Error: ' + response.status);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    document.querySelectorAll('[data-speed="1.2"]').forEach((item) => {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5,
        },
      });

      tl.to(item, {
        y: 0,
      });
    });
  }, []);

  useEffect(() => {
    document.querySelectorAll('[data-fade-in-play="true"]').forEach((item) => {
      ScrollTrigger.create({
        trigger: item,
        start: 'top bottom',
        onEnter: () => {
          if (item.played.length === 0) {
            item.play();
          }
        },
      });
    });
  }, []);

  return (
    <div className="App">
      <Header textData={textData} language={language} />
      <Overview textData={textData} language={language} />
      <MainPoint textData={textData} language={language} />
      <Hundred textData={textData} language={language} />
      <ParallaxLayout>
        <figure>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-coolingfan.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-coolingfan-cover.jpg"
          ></video>
          <div className="parallax-mask"></div>
        </figure>

        <div
          data-speed="1.2"
          style={{
            '--parallax-y': '160px',
            bottom: '-30%',
          }}
        >
          <h2
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text11']),
            }}
          ></h2>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text12']),
            }}
          ></h5>
        </div>
      </ParallaxLayout>

      <Small textData={textData} language={language} />

      <Temperature textData={textData} language={language} />

      <ParallaxLayout reverse={true}>
        <figure>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src={`https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-doubletwist${
              language === 'cn' ? '' : '-en'
            }.mp4`}
            poster={`https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-doubletwist-cover${
              language === 'cn' ? '' : '-en'
            }.jpg`}
          ></video>
          <div className="parallax-mask"></div>
        </figure>

        <div data-speed="1.2">
          <h2
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text21']),
            }}
          ></h2>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text22']),
            }}
          ></h5>
        </div>
      </ParallaxLayout>

      <ParallaxLayout>
        <figure>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src={`https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-bracket${
              language === 'cn' ? '' : '-en'
            }.mp4`}
            poster={`https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-bracket-cover${
              language === 'cn' ? '' : '-en'
            }.jpg`}
          ></video>
          <div className="parallax-mask"></div>
        </figure>

        <div data-speed="1.2">
          <h2
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text23']),
            }}
          ></h2>
          <h5
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text24']),
            }}
          ></h5>
        </div>
      </ParallaxLayout>

      <SwiperChangeLayout
        style={{
          '--theme-color': '#ff7733',
        }}
        title={textData['text25']}
        body={textData['text26']}
        content={[
          {
            mediaType: 'video',
            src: 'https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-play-01.mp4',
            poster:
              'https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-play-01-cover.jpg',
            text: DOMPurify.sanitize(textData['text27']),
          },
          {
            mediaType: 'video',
            src: 'https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-play-02.mp4',
            poster:
              'https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-play-02-cover.jpg',
            text: DOMPurify.sanitize(textData['text28']),
          },
          {
            mediaType: 'video',
            src: 'https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-play-03.mp4',
            poster:
              'https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-play-03-cover.jpg',
            text: DOMPurify.sanitize(textData['text29']),
          },
        ]}
      />

      <Battery textData={textData} language={language}></Battery>
    </div>
  );
}

export default App;
